// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__HMcRH","col":"Table_col__3fPRt","fulfillmentStatus":"Table_fulfillmentStatus__1BOD4","emailCol":"Table_emailCol__1-nXO"};